"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.runOne = exports.runOneAppOp = exports.runAll = exports.runAllWithProgress = exports.runAppOp = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var logic_1 = require("./logic");
var promise_1 = require("../promise");
var env_1 = require("../env");
var runAppOp = function (_a, appOp, exec) {
    var appByName = _a.appByName, deviceInfo = _a.deviceInfo;
    var app = appByName[appOp.name];
    if (!app) {
        var events = [
            {
                type: "runStart",
                appOp: appOp
            },
            {
                type: "runSuccess",
                appOp: appOp
            },
        ];
        // app not in list, we skip it.
        return (0, rxjs_1.from)(events);
    }
    return (0, rxjs_1.concat)((0, rxjs_1.of)({
        type: "runStart",
        appOp: appOp
    }), // we need to allow a 1s delay for the action to be achieved without glitch (bug in old firmware when you do things too closely)
    (0, rxjs_1.defer)(function () { return (0, promise_1.delay)((0, env_1.getEnv)("MANAGER_INSTALL_DELAY")); }).pipe((0, operators_1.ignoreElements)()), (0, rxjs_1.defer)(function () { return exec(appOp, deviceInfo.targetId, app); }).pipe((0, operators_1.throttleTime)(100), (0, operators_1.materialize)(), (0, operators_1.map)(function (n) {
        var _a, _b;
        switch (n.kind) {
            case "N":
                return {
                    type: "runProgress",
                    appOp: appOp,
                    progress: (_b = (_a = n === null || n === void 0 ? void 0 : n.value) === null || _a === void 0 ? void 0 : _a.progress) !== null && _b !== void 0 ? _b : 0
                };
            case "E":
                return {
                    type: "runError",
                    appOp: appOp,
                    error: n.error
                };
            case "C":
                return {
                    type: "runSuccess",
                    appOp: appOp
                };
            default:
                throw new Error("invalid notification of kind=" + n.kind);
        }
    })));
};
exports.runAppOp = runAppOp;
var runAllWithProgress = function (state, exec, precision) {
    if (precision === void 0) { precision = 100; }
    var total = state.uninstallQueue.length + state.installQueue.length;
    function globalProgress(s, localProgress) {
        var p = 1 -
            (s.uninstallQueue.length + s.installQueue.length - localProgress) / total;
        p = Math.round(p * precision) / precision;
        return p;
    }
    return rxjs_1.concat.apply(void 0, __spreadArray([], __read((0, logic_1.getActionPlan)(state).map(function (appOp) { return (0, exports.runAppOp)(state, appOp, exec); })), false)).pipe((0, operators_1.map)(function (event) {
        return ({
            type: "onRunnerEvent",
            event: event
        });
    }), (0, operators_1.scan)(logic_1.reducer, state), (0, operators_1.mergeMap)(function (s) {
        var currentProgressSubject = s.currentProgressSubject;
        if (!currentProgressSubject)
            return (0, rxjs_1.of)(globalProgress(s, 0));
        return currentProgressSubject.pipe((0, operators_1.map)(function (v) { return globalProgress(s, v); }));
    }), (0, operators_1.distinctUntilChanged)());
};
exports.runAllWithProgress = runAllWithProgress;
// use for CLI, no change of the state over time
var runAll = function (state, exec) {
    return rxjs_1.concat.apply(void 0, __spreadArray([], __read((0, logic_1.getActionPlan)(state).map(function (appOp) { return (0, exports.runAppOp)(state, appOp, exec); })), false)).pipe((0, operators_1.map)(function (event) {
        return ({
            type: "onRunnerEvent",
            event: event
        });
    }), (0, operators_1.reduce)(logic_1.reducer, state));
};
exports.runAll = runAll;
var runOneAppOp = function (state, appOp, exec) {
    return (0, exports.runAppOp)(state, appOp, exec).pipe((0, operators_1.map)(function (event) {
        return ({
            type: "onRunnerEvent",
            event: event
        });
    }), (0, operators_1.reduce)(logic_1.reducer, state));
};
exports.runOneAppOp = runOneAppOp;
var runOne = function (state, exec) {
    var next = (0, logic_1.getNextAppOp)(state);
    if (!next)
        return (0, rxjs_1.of)(state);
    return (0, exports.runOneAppOp)(state, next, exec);
};
exports.runOne = runOne;
//# sourceMappingURL=runner.js.map